/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { makeStyles } from '@mui/styles';
import Search from 'apollo-react-icons/Search';
import classNames from 'classnames';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { ZOOM_STYLES } from '../../constants/CommonStylesConstants';
import ZoomDialog from '../../form-designer/controls/ssZoom/ZoomDialog';
import { getSavedSearchTitle } from '../../saved-search-designer/selectors/editor.selectors';
import { getUITA } from '../../utils/commonUtils';

const useStyles = makeStyles({
  ...ZOOM_STYLES,
  control: {
    marginLeft: -42,
    zIndex: 10,
    marginTop: 7,
    '@media (max-width: 480px)': {
      marginTop: 45,
    },
  },
  inTable: {
    marginLeft: -42,
    zIndex: 10,
    marginTop: 12,
    position: 'absolute',
  },
});

const ZoomControl = ({
  title,
  entityName,
  savedSearchName,
  handleOnSelect,
  inTable = false,
  multiSelect = false,
}) => {
  const classes = useStyles();
  const searchTableTitle = useSelector((state) =>
    getSavedSearchTitle(state, {
      entityName,
      savedSearchName,
      defaultTitle: title,
    })
  );

  const [dialogOpen, setDialogOpen] = useState(false);

  const onSelect = (selection) => {
    setDialogOpen(false);
    handleOnSelect(selection);
  };

  return (
    <>
      <span
        className={classNames(classes.root, inTable ? classes.inTable : classes.control)}
        onClick={() => setDialogOpen(true)}
      >
        <Search className={classes.searchIcon} />
      </span>
      <ZoomDialog
        open={dialogOpen}
        onSelect={onSelect}
        onClose={() => setDialogOpen(false)}
        multiSelect={multiSelect}
        entityName={entityName}
        initialSearchName={savedSearchName}
        customFilter={{}}
        title={searchTableTitle}
        referencedColumns={[]}
        translatedSearchName={searchTableTitle}
        ui-ta={getUITA('RightsDialog')}
        dynamicParamCollection={{}}
      />
    </>
  );
};

export default ZoomControl;
